import { BalancesTable } from "./balances";
import { ExcursionsTable } from "./excursions";
import { FlightsTable } from "./flights";
import { TravelProtectionTable } from "./travel-protection";
import {
    ConfirmedRequestedGroupMemberTripsFragment,
    GroupMembersDepartureFragment,
} from "generated/graphql";
import React from "react";
import { ContactInfoTable } from "./contact-info";
import { RoomingTable } from "./rooming/RoomingTable";
import { TermsTable } from "./terms";
import { TourStatusTable } from "./tour-status/TourStatusTable";

type BookedTravelersPagesProps = {
    departure: GroupMembersDepartureFragment;
    selectedPage: string;
    bookedSortedTravelers: ConfirmedRequestedGroupMemberTripsFragment[][];
    hasExtension: boolean;
    emailHelpTextId: string;
};

export const BookedTravelersPages: React.FC<BookedTravelersPagesProps> = ({
    departure,
    selectedPage,
    bookedSortedTravelers,
    hasExtension,
    emailHelpTextId,
}) => {
    const renderBookedTravelersPages = () => {
        try {
            switch (selectedPage) {
                case "TourStatus":
                    return (
                        <TourStatusTable
                            bookedTravelers={bookedSortedTravelers}
                            hasExtension={hasExtension}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "Balances":
                    return (
                        <BalancesTable
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "Terms":
                    return (
                        <TermsTable
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "Excursions":
                    return (
                        <ExcursionsTable
                            excursions={departure.excursions}
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "TravelProtection":
                    return (
                        <TravelProtectionTable
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "Flights":
                    return (
                        <FlightsTable
                            departure={departure}
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "ContactInfo":
                    return (
                        <ContactInfoTable
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                case "Rooming":
                    return (
                        <RoomingTable
                            hasExtension={hasExtension}
                            departure={departure}
                            bookedTravelers={bookedSortedTravelers}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
                default:
                    return (
                        <TourStatusTable
                            bookedTravelers={bookedSortedTravelers}
                            hasExtension={hasExtension}
                            emailHelpTextId={emailHelpTextId}
                        />
                    );
            }
        } catch {
            throw new Error("Error rendering booked travelers pages");
        }
    };

    return <>{renderBookedTravelersPages()}</>;
};
